"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IconContainer_1 = __importStar(require("../IconContainer"));
const AlarmIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsxs)(IconContainer_1.StyledSvg, { fill: "none", height: size, viewBox: "0 0 24 24", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: [(0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M21.269 7.335a3.294 3.294 0 00-.218-4.382c-1.08-1.082-2.743-1.241-4.01-.484a10.077 10.077 0 014.228 4.866zM6.956 2.478a3.271 3.271 0 00-4.007.475 3.294 3.294 0 00-.21 4.393 10.077 10.077 0 014.217-4.868z", fillRule: "evenodd" }), (0, jsx_runtime_1.jsx)("path", { d: "M12.006 2.916c-4.522 0-8.193 3.693-8.193 8.216 0 4.536 3.671 8.217 8.193 8.217 4.523 0 8.193-3.694 8.193-8.217 0-4.523-3.67-8.216-8.193-8.216z" }), (0, jsx_runtime_1.jsx)("path", { d: "M4.628 22l5.712-9.059h3.32L19.385 22h-2.687l-4.691-4.699L7.315 22H4.628z" }), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M10.981 12.062v-5.88h2.076v5.53l2.195 2.914-1.656 1.255-2.405-3.191a1.043 1.043 0 01-.21-.628z", fill: "#fff", fillRule: "evenodd" })] }));
exports.default = (0, IconContainer_1.default)(AlarmIcon);
//# sourceMappingURL=index.js.map